/**
 * Utility functions for handling Telegram theme parameters
 */

/**
 * Applies Telegram theme parameters to CSS variables
 * @param {Object} themeParams - Theme parameters from Telegram WebApp
 */
export const applyTelegramTheme = (themeParams) => {
  if (!themeParams) return;
  
  const root = document.documentElement;
  
  // Apply colors to CSS variables
  Object.entries(themeParams).forEach(([key, value]) => {
    const cssVarName = `--tg-${key.replace(/_/g, '-')}`;
    root.style.setProperty(cssVarName, value);
  });
  
  // Set theme mode based on background color
  const bgColor = themeParams.bg_color || '#ffffff';
  const isLight = isLightColor(bgColor);
  
  if (isLight) {
    root.classList.add('theme-light');
    root.classList.remove('theme-dark');
  } else {
    root.classList.add('theme-dark');
    root.classList.remove('theme-light');
  }
};

/**
 * Determines if a color is light or dark
 * @param {string} hexColor - Color in hex format (#RRGGBB)
 * @returns {boolean} - True if the color is light, false if dark
 */
export const isLightColor = (hexColor) => {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128;
}; 